<template>
	<div>
		<loader v-if="!activeItem"/>
		<template v-else>
			<header class="flex gap-2 content-between">
				<h1 class="alpha heavy" v-html="activeItem.profile.name"/>
				<dl>
					<div class="flex gap-0-5 items-center">
						<dt>API Key:</dt>
						<dd v-html="activeItem.apiKey.key"/>
					</div>
				</dl>
			</header>
			<div>
				<v-tabs :mountOnShow="true" :mountOnce="true" class="tabs--switch tabs--switch--shadow">
					<v-tab id="general" label="General">
						<service-provider-form
							:service-provider="activeItem" cta="Update Service Provider" method="patch"/>
					</v-tab>
					<v-tab id="settings" label="Settings">
						<settings-forms :service-provider="activeItem"/>
					</v-tab>
					<v-tab id="fees" label="Fees">
						<v-tabs v-slot="{ goToTab }" :tabless="true" :updateHash="false">
							<v-tab id="list-fees" class="section" label="Fees">
								<header>
									<h2>Fees</h2>
									<button
										class="button button--primary--small"
										@click.prevent="goToTab('create-fees')">Create Or Edit Fees
									</button>
								</header>
								<table>
									<thead>
										<tr>
											<th align="left">Service</th>
											<th align="left">Introducer</th>
										</tr>
									</thead>
									<tbody>
										<template v-for="serviceFees in activeItem.fees">
											<tr
												v-for="(introducerFees, introducer) in serviceFees.introducers"
												:key="introducer">
												<td v-html="serviceFees.service.names.plural"/>
												<td v-if="!introducerFees.introducer">—</td>
												<td
													v-else
													v-html="introducerFees.introducer.profile.name"/>
											</tr>
										</template>
									</tbody>
								</table>
							</v-tab>
							<v-tab id="create-fees" label="Create Fees">
								<fees-form :service-provider="activeItem" v-on:cancelled="goToTab('list-fees')"/>
							</v-tab>
						</v-tabs>
					</v-tab>
					<v-tab id="tags" label="tags">
						<tags-form :service-provider="activeItem"/>
					</v-tab>
				</v-tabs>
			</div>
		</template>
	</div>
</template>
<script>
import {mapActions, mapGetters} from "vuex";
import ServiceProviderForm from "./forms/ServiceProviderForm";
import SettingsForms from "./forms/SettingsForms";
import FeesForm from "../../../../components/forms/FeesForm";
import TagsForm from "./forms/TagsForm";

export default {
	components: {
		ServiceProviderForm,
		SettingsForms,
		FeesForm,
		TagsForm,
	},

	computed: {
		...mapGetters("serviceProviders", [
			"activeItem",
		]),
	},

	methods: {
		...mapActions("serviceProviders", [
			"activateModel",
		]),
	},

	created() {
		this.activateModel(this.$route.params.serviceProvider);
	},
};
</script>
